import types from './types';


const updateHeaderProps = data => ({
	type: types.UPDATE_HEADER_PROPS,
	payload: data
});

export default {
	updateHeaderProps
};
